/* ==========================================================================
   Lumé Beauty Lab · website 2.0 · gedrag
   Zonder bibliotheken. Shopify thema: window.LUME komt uit snippets/lume-data.liquid
   (producten, prijzen, voorraad, metavelden en thema-instellingen); de tas is de
   echte Shopify winkelmand via de Ajax Cart API.
   Dit bestand: alles wat op elke pagina zit (kop, menu, zoeken, tas met
   kortingsmeter, productkaart) en de secties van de homepagina.
   lume-shop.js: collectie, productpagina, winkelmandpagina, kassa.
   ========================================================================== */
(function () {
  'use strict';
  var L = window.LUME, R = L.ROUTES || {}, IMAGES = L.IMAGES, VIDEOS = L.VIDEOS || {}, PHASE = L.PHASE, PRODUCTS = L.PRODUCTS, GIFT = L.GIFT || { threshold: 0, name: 'Lumé mirror' }, SHIP = L.SHIPPING, ROUTINES = L.ROUTINES || [];
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return '€' + (Math.round(n * 100) / 100).toFixed(2); };
  var euro = function (n) { return '€' + (n % 1 ? n.toFixed(2) : n); };
  /* korting in hele centen, zodat kaart, routine en tas altijd hetzelfde bedrag tonen */
  var discOf = function (sub, pct) { return Math.round(sub * pct) / 100; };
  var icon = function (n) { return '<svg class="icon" aria-hidden="true"><use href="#i-' + n + '"/></svg>'; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var byHandle = {}; var byVariant = {};
  PRODUCTS.forEach(function (p) { byHandle[p.handle] = p; p.variants.forEach(function (v) { byVariant[v.id] = { p: p, v: v }; }); });
  var DETAILS = L.DETAILS || {};
  /* een variant zoeken op product en tintnaam (routines en voorbeeldreviews staan zo in het thema) */
  function vidOf(handle, title) {
    var p = byHandle[handle]; if (!p) return null;
    if (!title) return p.variants[0].id;
    var t = String(title).toLowerCase(), hit = p.variants.filter(function (v) { return v.title.toLowerCase() === t; })[0];
    return hit ? hit.id : null;
  }
  ROUTINES = ROUTINES.map(function (r) {
    var picks = (r.picks || []).map(function (x) { return typeof x === 'string' ? (byVariant[x] ? x : null) : vidOf(x[0], x[1]); });
    return picks.some(function (x) { return !x; }) ? null : { id: r.id, name: r.name, color: r.color, picks: picks };
  }).filter(Boolean);
  L.ROUTINES = ROUTINES;
  /* adres van een productpagina; met een tint erachter opent de pagina op die tint (in Shopify: ?variant=) */
  var urlOf = function (p, v) { return v && v.url ? v.url : (p.page || '#') + (v && p.variants.length > 1 ? '?variant=' + v.id : ''); };

  /* ---------- beeld ---------- */
  var SETS = L.SETS || {}, GALLERY = L.GALLERY || {};
  var SZ = {
    card: '(max-width:800px) 62vw, (max-width:1100px) 31vw, 23vw',
    mini: '(max-width:800px) 46vw, 210px',
    step: '(max-width:700px) 104px, (max-width:1100px) 28vw, 16vw',
    line: '76px',
    finder: '(max-width:900px) 100vw, 40vw',
    tile: '(max-width:900px) 48vw, 23vw'
  };
  /* src + srcset voor een beeldsleutel: de browser kiest de maat die bij het scherm past */
  function srcAttrs(key, sizes) {
    var set = SETS[key];
    return (set ? 'src="' + IMAGES[key] + '" srcset="' + set + '" sizes="' + sizes + '"' : 'src="' + (IMAGES[key] || '') + '"');
  }
  function setImg(im, key, sizes) {
    if (SETS[key]) { im.sizes = sizes; im.srcset = SETS[key]; im.src = IMAGES[key]; }
    else { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = IMAGES[key]; }
  }
  function fillImages(root) {
    $$('img[data-img]', root).forEach(function (im) {
      var key = im.getAttribute('data-img'), src = IMAGES[key];
      if (!src) return;
      if (SETS[key]) setImg(im, key, im.getAttribute('data-sizes') === 'finder' ? SZ.finder : SZ.tile);
      else if (im.getAttribute('src') !== src) im.src = src;
    });
  }

  /* ---------- teksten uit de instellingen: cadeaudrempel en verzendkosten ---------- */
  (function () {
    var t = GIFT.threshold, from = t > 0;
    var txt = {
      bar: from ? 'A Lumé mirror with orders from ' + euro(t) : 'A Lumé mirror with every order, on us',
      usp: from ? 'A Lumé mirror with orders from ' + euro(t) : 'A Lumé mirror with every order',
      h: from ? 'The Lumé mirror, on us from ' + euro(t) + '.' : 'A mirror with every order.',
      p: from ? 'For the touch-up on the way out. Order for ' + euro(t) + ' or more and the Lumé compact mirror comes with it, on us.' : 'For the touch-up on the way out. The Lumé compact mirror comes with every order, on us.'
    };
    $$('[data-gift-text]').forEach(function (el) { var k = el.getAttribute('data-gift-text'); if (txt[k]) el.textContent = txt[k]; });
    if (SHIP) {
      $$('[data-ship-text]').forEach(function (el) { el.textContent = 'Shipping NL ' + money(SHIP.nl) + ' · EU ' + money(SHIP.eu) + ' · Worldwide' + (SHIP.world != null ? ' ' + money(SHIP.world) : ''); });
      var sn = $('#shipNote'); if (sn) sn.textContent = shipLine();
    }
  })();

  /* ---------- de actie: één plek voor de tekst, zodat een nieuwe fase overal tegelijk klopt ---------- */
  var LAD = PHASE.ladder, TOP = Math.max.apply(null, LAD);
  var PROMO = {
    tag: LAD[0] > 0 ? 'Save ' + LAD[0] + ' to ' + TOP + '%' : 'Save up to ' + TOP + '%',
    line: (LAD[0] > 0 ? '1 item ' + LAD[0] + '% off · ' : '') + '2 items ' + LAD[1] + '% off · 3 or more ' + LAD[2] + '% off · applied at checkout',
    pair: 'Add a gloss: ' + LAD[1] + '% off both · make it three: ' + LAD[2] + '% off · at checkout',
    deal: (LAD[0] > 0 ? LAD[0] + '% off · ' : '') + LAD[1] + '% off with 2 · ' + LAD[2] + '% off with 3 or more, at checkout',
    /* de korting wordt in de kassa berekend: deze zin staat bij elke meter, in de tas en bij de routine */
    note: 'Your discount is applied automatically at checkout. No code needed.',
    short: 'Discount applied at checkout'
  };
  function fillPromo(root) { $$('[data-promo]', root).forEach(function (el) { var t = PROMO[el.getAttribute('data-promo')]; if (t) el.textContent = t; }); }
  fillPromo(document);

  /* ---------- video: bron pas zetten als hij nodig is ---------- */
  /* eigen video uit de thema-editor: bron en poster staan op het element zelf */
  function vidData(v) { var d = VIDEOS[v.getAttribute('data-video')]; if (!d && v.getAttribute('data-src')) d = { src: v.getAttribute('data-src'), poster: v.getAttribute('data-poster') || '' }; return d; }
  function armVideo(v) {
    var d = vidData(v); if (!d) return v;
    if (!v.getAttribute('poster')) v.poster = d.poster;
    if (!v.getAttribute('src')) { v.muted = true; v.src = d.src; }
    return v;
  }
  function playVideo(v) { armVideo(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  $$('video[data-video]').forEach(function (v) { var d = vidData(v); if (d && d.poster) v.poster = d.poster; });

  /* ---------- toast ---------- */
  var toastEl = $('#toast'), toastT;
  function toast(msg) {
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-note]');
    if (a) { e.preventDefault(); toast(a.getAttribute('data-note')); }
  });

  /* ---------- productkaart ---------- */
  function badgesFor(p, v) {
    var out = [];
    /* de actie op elke productfoto, zoals bij Huda: volgt de ladder van de fase */
    if (TOP > 0 && !p.noLadder) out.push('<span class="badge badge--promo" title="' + PROMO.line + '">' + PROMO.tag + '</span>');
    (p.badges || []).forEach(function (b) { out.push('<span class="badge' + (b === 'Bestseller' ? ' badge--noir' : '') + '">' + esc(b) + '</span>'); });
    if (p.worth) out.push('<span class="badge">Save ' + money(p.worth - v.price) + '</span>');
    if (v.stock === 0) out.push('<span class="badge badge--signal">Sold out</span>');
    else if (v.stock != null && v.stock <= L.LOW_STOCK) out.push('<span class="badge badge--signal">Only ' + v.stock + ' left</span>');
    return out.join('');
  }
  function swatches(p, sel) {
    if (!p.option) return '';
    return p.variants.map(function (v, i) {
      return '<button type="button" class="sw__dot' + (i === sel ? ' is-on' : '') + '" style="background:' + v.color + '" data-v="' + i + '" aria-label="' + esc(v.title) + '" aria-pressed="' + (i === sel) + '" title="' + esc(v.title) + '"></button>';
    }).join('') + '<span class="sw__name">' + esc(p.variants[sel].title) + '</span>';
  }
  var STARS = '<span class="stars" aria-hidden="true">' + new Array(6).join(icon('star')) + '</span>';
  /* reviews: zolang REVIEWS.sample aan staat zijn het voorbeeldteksten en draagt alles het label "Example" */
  var REVIEWS = L.REVIEWS || { sample: false, items: {} };
  function reviewsOf(p) {
    return ((REVIEWS.items || {})[p.handle] || []).map(function (r) { return [r[0], r[1], r[2] && !byVariant[r[2]] ? vidOf(p.handle, r[2]) : r[2]]; });
  }
  function rateHTML(p) {
    var n = reviewsOf(p).length;
    if (!n) return '<div class="rate">' + STARS + '<span>No reviews yet</span></div>';
    return '<a class="rate rate--on" href="' + urlOf(p) + '#reviews">' + STARS + '<span>' + (REVIEWS.sample ? 'Example reviews' : n + (n === 1 ? ' review' : ' reviews')) + '</span></a>';
  }
  /* r = [kop, tekst, variant id]; withProd = met het product eronder (collectie, routine) */
  function reviewHTML(p, r, withProd) {
    var x = r[2] && byVariant[r[2]] ? byVariant[r[2]] : { p: p, v: p.variants[0] };
    return '<article class="rv"' + (REVIEWS.sample ? ' data-sample' : '') + '>' + (REVIEWS.sample ? '<span class="rv__tag">Example</span>' : '') +
      '<span class="stars" role="img" aria-label="5 out of 5 stars">' + new Array(6).join(icon('star')) + '</span>' +
      '<h3 class="rv__title">“' + esc(r[0]) + '”</h3><p class="rv__text">' + esc(r[1]) + '</p>' +
      (withProd
        ? '<a class="rv__prod" href="' + urlOf(x.p, r[2] ? x.v : null) + '"><img ' + srcAttrs(x.v.image, '52px') + ' alt="' + esc(x.p.title) + '" width="52" height="52" loading="lazy"><span><b>' + esc(x.p.title + (r[2] && x.p.option ? ' · ' + x.v.title : '')) + '</b><small>' + (REVIEWS.sample ? 'First name, city' : '') + '</small></span></a>'
        : '<p class="rv__by">' + (r[2] && x.p.option ? esc(x.v.title) + ' · ' : '') + (REVIEWS.sample ? 'First name, city' : '') + '</p>') +
      '</article>';
  }
  /* de foto's in de kaart: 1 product, 2 product naast verpakking, 3 model (waar die er is) */
  var shotLabel = function (k, i) { return /^model-/.test(k) ? 'On the lips' : /-pack$/.test(k) ? 'With packaging' : /-full$/.test(k) ? 'The full set' : i === 0 ? 'Product' : 'Photo ' + (i + 1); };
  function mediaHTML(p, v) {
    var g = GALLERY[v.image] || [v.image], alt = p.title + (p.option ? ' in ' + v.title : '');
    return '<a class="card__link" href="' + urlOf(p, v) + '" aria-label="' + esc(p.title) + '">' +
      g.map(function (k, i) {
        return i === 0
          ? '<img class="card__img is-on" data-key="' + k + '" ' + srcAttrs(k, SZ.card) + ' alt="' + esc(alt) + '" loading="lazy">'
          : '<img class="card__img" data-key="' + k + '" alt="' + esc(alt + ', ' + shotLabel(k, i).toLowerCase()) + '">';
      }).join('') + '</a>' +
      '<span class="badges">' + badgesFor(p, v) + '</span>' +
      (g.length > 1 ? '<div class="card__dots" role="group" aria-label="Photos">' + g.map(function (k, i) {
        return '<button type="button" class="card__dot' + (i === 0 ? ' is-on' : '') + '" data-g="' + i + '" aria-label="' + shotLabel(k, i) + '" title="' + shotLabel(k, i) + '"></button>';
      }).join('') + '</div>' : '');
  }
  function showShot(card, i) {
    var imgs = $$('.card__img', card), dots = $$('.card__dot', card); if (imgs.length < 2) return;
    i = (i + imgs.length) % imgs.length;
    var im = imgs[i]; if (!im.getAttribute('src')) setImg(im, im.getAttribute('data-key'), SZ.card);
    var nx = imgs[(i + 1) % imgs.length]; if (!nx.getAttribute('src')) setImg(nx, nx.getAttribute('data-key'), SZ.card);
    imgs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
    dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    card._shot = i;
  }
  function cardHTML(p, sel) {
    var v = p.variants[sel];
    return '<article class="card" data-handle="' + p.handle + '" data-sel="' + sel + '">' +
      '<div class="card__media">' + mediaHTML(p, v) + '</div>' +
      '<div class="card__body">' +
        '<h3 class="card__t"><a href="' + urlOf(p, v) + '">' + esc(p.title) + '</a></h3>' +
        '<p class="card__s">' + esc(p.subtitle) + '</p>' +
        (p.noLadder ? '<div class="rate"></div><div class="sw"><span class="sw__name" style="margin:0">' + p.variants.map(function (x) { return esc(x.title); }).join(' · ') + '</span></div>'
          : rateHTML(p) + '<div class="sw">' + swatches(p, sel) + '</div>') +
        '<div class="card__foot"><span class="price">' + (p.noLadder ? 'From ' : '') + money(v.price) + (p.worth ? '<small>worth ' + money(p.worth) + '</small>' : '') + '</span></div>' +
        (p.noLadder ? '<p class="card__deal" style="color:var(--muted)">Sent by email</p>' : '<p class="card__deal">' + PROMO.deal + '</p>') +
        '<div class="card__add">' + (p.noLadder ? '<a class="btn btn--solid btn--full" href="' + urlOf(p) + '">Choose amount</a>' : '<button type="button" class="btn btn--solid btn--full" data-add' + (v.stock === 0 ? ' disabled' : '') + '>' + (v.stock === 0 ? 'Sold out' : 'Add to bag') + '</button>') + '</div>' +
      '</div></article>';
  }
  function promoHTML() {
    var l = PHASE.ladder;
    return '<a class="card card--promo" href="' + R.routine + '" style="background:var(--sand);padding:28px 24px;justify-content:space-between;min-height:100%">' +
      '<span class="label">' + esc(PHASE.name) + '</span>' +
      '<span><span class="serif" style="font-size:clamp(26px,2.4vw,36px);line-height:1.1;display:block">Line. Gloss. Care.</span>' +
      '<span style="display:block;margin-top:12px;color:var(--muted)">Two items, ' + l[1] + '% off. Three or more, ' + l[2] + '% off your order, applied at checkout.</span></span>' +
      '<span class="link" style="align-self:flex-start">Build your routine</span></a>';
  }
  /* kaartgedrag: tint kiezen en in de tas */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.card .sw__dot');
    if (dot) {
      var card = dot.closest('.card'), p = byHandle[card.dataset.handle], i = +dot.dataset.v, v = p.variants[i];
      card.dataset.sel = i;
      clearInterval(card._cycle);
      var media = $('.card__media', card);
      media.classList.add('is-swap');
      setTimeout(function () { media.innerHTML = mediaHTML(p, v); media.classList.remove('is-swap'); }, 160);
      $('.sw', card).innerHTML = swatches(p, i);
      $('.price', card).firstChild.nodeValue = money(v.price);
      var tl = $('.card__t a', card); if (tl) tl.setAttribute('href', urlOf(p, v));
      var ab = $('[data-add]', card); if (ab) { ab.disabled = v.stock === 0; ab.textContent = v.stock === 0 ? 'Sold out' : 'Add to bag'; }
      return;
    }
    var add = e.target.closest('.card [data-add]');
    if (add) {
      var c = add.closest('.card'), pp = byHandle[c.dataset.handle];
      bagAdd(pp.variants[+c.dataset.sel].id, 1); openDrawer('bag');
    }
  });

  /* onder de muis: naar foto 2, en bij drie foto's rustig doorlopen; weg met de muis: terug naar het product */
  var canHover = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if (canHover) {
    document.addEventListener('mouseenter', function (e) {
      var m = e.target; if (!m.classList || !m.classList.contains('card__media')) return;
      var card = m.closest('.card'), n = $$('.card__img', card).length; if (n < 2) return;
      clearInterval(card._cycle); card._held = false; showShot(card, 1);
      if (n > 2 && !REDUCE) card._cycle = setInterval(function () { if (!card._held) showShot(card, (card._shot || 0) + 1); }, 1700);
    }, true);
    document.addEventListener('mouseleave', function (e) {
      var m = e.target; if (!m.classList || !m.classList.contains('card__media')) return;
      var card = m.closest('.card'); clearInterval(card._cycle); if (!card._held) showShot(card, 0);
    }, true);
  }
  /* de streepjes: zelf een foto kiezen (ook op een telefoon) */
  document.addEventListener('click', function (e) {
    var d = e.target.closest && e.target.closest('.card__dot'); if (!d) return;
    e.preventDefault(); var card = d.closest('.card'); card._held = true; clearInterval(card._cycle); showShot(card, +d.dataset.g);
  });

  /* ---------- tabs + rail ---------- */
  var explode = function (handle) { return byHandle[handle] ? byHandle[handle].variants.map(function (_, i) { return [handle, i]; }) : []; };
  var has = function (it) { return it === 'promo' || !!byHandle[it[0]]; };
  var TABS = [
    { id: 'best', label: 'Bestsellers', items: [['signature-gloss', 0], ['signature-glow-duo', 0], ['pink-cloud', 0], 'promo'] },
    { id: 'gloss', label: 'Gloss', items: [['signature-gloss', 0], ['pink-cloud', 0]].concat(explode('lip-glow-oil')) },
    { id: 'liner', label: 'Lip Liner', items: explode('lip-liner') },
    { id: 'care', label: 'Lip Care', items: explode('lip-butter-balm').concat(['promo']) },
    { id: 'sets', label: 'Sets', items: [['signature-glow-duo', 0], ['the-kiss-edit', 0], ['gift-card', 0], 'promo'] },
    { id: 'all', label: 'Shop All', items: PRODUCTS.filter(function (p) { return !p.noLadder; }).map(function (p) { return [p.handle, 0]; }) }
  ];
  var rail = $('#rail'), tabsEl = $('#tabs'), railBar = $('#railBar'), prevB = $('#railPrev'), nextB = $('#railNext');
  function renderTab(id) {
    var t = TABS.filter(function (x) { return x.id === id; })[0];
    $$('.tab', tabsEl).forEach(function (b) { var on = b.dataset.tab === id; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
    rail.innerHTML = t.items.filter(has).map(function (it) { return it === 'promo' ? promoHTML() : cardHTML(byHandle[it[0]], it[1]); }).join('');
    rail.scrollLeft = 0; railState();
  }
  function railState() {
    var max = rail.scrollWidth - rail.clientWidth;
    prevB.disabled = rail.scrollLeft < 4; nextB.disabled = rail.scrollLeft > max - 4;
    var w = Math.min(100, rail.clientWidth / rail.scrollWidth * 100);
    railBar.style.width = w + '%'; railBar.style.left = (max > 0 ? rail.scrollLeft / max * (100 - w) : 0) + '%';
  }
  if (rail && tabsEl) {
    tabsEl.innerHTML = TABS.map(function (t) { return '<button type="button" class="tab" role="tab" data-tab="' + t.id + '">' + t.label + '</button>'; }).join('');
    tabsEl.addEventListener('click', function (e) { var b = e.target.closest('.tab'); if (b) renderTab(b.dataset.tab); });
    var step = function (d) { var c = rail.firstElementChild; rail.scrollBy({ left: d * ((c ? c.offsetWidth : 300) + 20) * 2, behavior: 'smooth' }); };
    prevB.addEventListener('click', function () { step(-1); }); nextB.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', railState, { passive: true }); window.addEventListener('resize', railState);
    renderTab('best');
    document.addEventListener('click', function (e) { var g = e.target.closest('[data-tab-go]'); if (g) renderTab(g.getAttribute('data-tab-go')); });
  }

  /* ---------- mini kaarten (megamenu, zoeken) ---------- */
  /* vi = een vaste tint (voor het menu van liners en lip care); zonder vi het product als geheel */
  function miniHTML(p, vi) {
    var one = typeof vi === 'number' && p.variants[vi], v = one ? p.variants[vi] : p.variants[0];
    var from = !one && p.variants.some(function (x) { return x.price !== v.price; }) ? 'From ' : '';
    var min = one ? v.price : Math.min.apply(null, p.variants.map(function (x) { return x.price; }));
    return '<a class="mini" href="' + urlOf(p, one ? v : null) + '"><span class="mini__img"><img ' + srcAttrs(v.image, SZ.mini) + ' alt="' + esc(p.title + (one ? ' in ' + v.title : '')) + '" loading="lazy"></span>' +
      '<span class="mini__t" style="display:block">' + esc(one ? v.title : p.title) + '</span><span class="mini__p">' + (one ? esc(p.title) + ' · ' : from) + money(min) + (!one && p.option && !p.noLadder ? ' · ' + p.variants.length + ' shades' : '') + '</span>' + (p.noLadder ? '' : '<span class="mini__tag">' + PROMO.tag + '</span>') + '</a>';
  }
  $$('[data-minis]').forEach(function (el) {
    el.innerHTML = el.getAttribute('data-minis').split(',').map(function (h) { var x = h.trim().split(':'); return byHandle[x[0]] ? miniHTML(byHandle[x[0]], x.length > 1 ? +x[1] : undefined) : ''; }).join('');
  });

  /* ---------- aankondigingsbalk ---------- */
  (function () {
    var msgs = $$('.bar__msg'), i = 0, t;
    if (!msgs.length || !$('#barPrev')) return;
    function show(n) { msgs[i].classList.remove('is-on'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('is-on'); }
    function play() { clearInterval(t); t = setInterval(function () { show(i + 1); }, 5000); }
    $('#barPrev').addEventListener('click', function () { show(i - 1); play(); });
    $('#barNext').addEventListener('click', function () { show(i + 1); play(); });
    play();
  })();

  /* ---------- usp: lopende band (inhoud vier keer, zodat de lus naadloos is) ---------- */
  (function () {
    var tr = $('#uspTrack'); if (!tr || REDUCE) return;
    var base = tr.innerHTML, extra = '';
    for (var k = 0; k < 3; k++) extra += base;
    var tmp = document.createElement('div'); tmp.innerHTML = extra;
    $$('.usp__item', tmp).forEach(function (el) { el.setAttribute('aria-hidden', 'true'); tr.appendChild(el); });
  })();

  /* ---------- header: schaduw + megamenu ---------- */
  var head = $('.head');
  if (head) window.addEventListener('scroll', function () { head.classList.toggle('is-stuck', window.scrollY > 40); }, { passive: true });
  $$('.nav__item').forEach(function (it) {
    if (!$('.mega', it)) return;
    var t;
    var open = function () { clearTimeout(t); $$('.nav__item.is-open').forEach(function (o) { if (o !== it) o.classList.remove('is-open'); }); it.classList.add('is-open'); $('.nav__link', it).setAttribute('aria-expanded', 'true'); };
    var close = function () { t = setTimeout(function () { it.classList.remove('is-open'); $('.nav__link', it).setAttribute('aria-expanded', 'false'); }, 120); };
    it.addEventListener('mouseenter', open); it.addEventListener('mouseleave', close);
    it.addEventListener('focusin', open); it.addEventListener('focusout', close);
  });

  /* ---------- lades en zoeken ---------- */
  var scrim = $('#scrim'), openEl = null, lastFocus = null;
  function openDrawer(id) {
    closeDrawer(true);
    openEl = $('#' + id); if (!openEl) return;
    lastFocus = document.activeElement;
    openEl.classList.add('is-on'); openEl.setAttribute('aria-hidden', 'false'); scrim.classList.add('is-on'); document.body.classList.add('is-locked');
    var f = $('[data-autofocus]', openEl) || $('[data-close]', openEl); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer(silent) {
    if (!openEl) return;
    openEl.classList.remove('is-on'); openEl.setAttribute('aria-hidden', 'true'); scrim.classList.remove('is-on'); document.body.classList.remove('is-locked');
    openEl = null; if (!silent && lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target === scrim) closeDrawer();
    var j = e.target.closest('.drawer a[href^="#"], .search a[href^="#"]'); if (j) closeDrawer(true);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  $$('.mnav__row[aria-expanded]').forEach(function (b) {
    b.addEventListener('click', function () { var on = b.getAttribute('aria-expanded') === 'true'; b.setAttribute('aria-expanded', !on); b.nextElementSibling.classList.toggle('is-on', !on); });
  });

  var sIn = $('#searchInput'), sRes = $('#searchRes'), sHint = $('#searchHint');
  function search(q) {
    q = q.trim().toLowerCase();
    var hits = !q ? [] : PRODUCTS.filter(function (p) {
      return (p.title + ' ' + p.type + ' ' + p.subtitle + ' ' + p.variants.map(function (v) { return v.title + ' ' + (v.note || ''); }).join(' ')).toLowerCase().indexOf(q) > -1;
    });
    sRes.innerHTML = hits.map(function (p) { return miniHTML(p); }).join('');
    var all = $('#searchAll'); if (all) { all.hidden = !q; all.setAttribute('href', R.search + '?q=' + encodeURIComponent(q) + '&type=product'); }
    sHint.textContent = !q ? 'Popular searches' : hits.length ? hits.length + (hits.length === 1 ? ' result' : ' results') : 'Nothing found for “' + q + '”. Try gloss, liner or balm.';
  }
  if (sIn) {
    sIn.addEventListener('input', function () { search(sIn.value); });
    sIn.addEventListener('keydown', function (e) { var all = $('#searchAll'); if (e.key === 'Enter' && sIn.value.trim() && all) { e.preventDefault(); window.location.href = all.getAttribute('href'); } });
    $$('#searchPop .chip').forEach(function (c) { c.addEventListener('click', function () { sIn.value = c.textContent; search(sIn.value); sIn.focus(); }); });
  }

  /* ---------- winkelmand ----------
     De tas is de Shopify winkelmand (Ajax Cart API). Het thema rekent de korting alleen voor om te tonen;
     de echte korting is de automatische korting van Shopify en wordt in de kassa toegepast.
     De kortingsladder telt artikelen; een cadeaubon telt niet mee en krijgt zelf geen korting. */
  var bag = {}, bagSubs = [], giftAttr = false, queue = Promise.resolve();
  function fromCart(c) {
    bag = {};
    ((c && c.items) || []).forEach(function (it) { var id = String(it.variant_id); if (byVariant[id]) bag[id] = (bag[id] || 0) + it.quantity; });
    giftAttr = !!(c && c.attributes && c.attributes[GIFT.attr]);
  }
  fromCart(L.CART);
  function api(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function refresh() {
    return fetch(R.cart + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { fromCart(c); renderBag(); markGift(); });
  }
  /* de spiegel: vanaf de drempel staat er een notitie op de bestelling, zodat hij mee wordt ingepakt */
  function markGift() {
    var on = totals().gift;
    if (!GIFT.attr || on === giftAttr) return;
    giftAttr = on; var a = {}; a[GIFT.attr] = on ? 'Yes' : '';
    queue = queue.then(function () { return api(R.cartUpdate + '.js', { attributes: a }); }).catch(function () {});
  }
  function fail(e) { toast((e && (e.description || e.message)) || 'Something went wrong. Please try again.'); return refresh(); }
  function pctFor(n) { return n <= 0 ? 0 : LAD[Math.min(n, 3) - 1]; }
  /* alle bedragen van een tas op één plek: tas, winkelmandpagina en productpagina rekenen hiermee */
  function totals(b) {
    b = b || bag;
    var items = 0, n = 0, sub = 0, lsub = 0;
    Object.keys(b).forEach(function (id) {
      var x = byVariant[id], q = b[id]; if (!x || q <= 0) return;
      items += q; sub += x.v.price * q;
      if (!x.p.noLadder) { n += q; lsub += x.v.price * q; }
    });
    var pct = pctFor(n), disc = discOf(lsub, pct), goods = lsub - disc;
    return {
      items: items, n: n, sub: sub, pct: pct, disc: disc, total: sub - disc, goods: goods,
      nextPct: n === 1 ? LAD[1] : n === 2 ? LAD[2] : 0,
      /* cadeau: de spiegel gaat mee vanaf de cadeaudrempel, gerekend na korting en zonder verzending */
      gift: GIFT.threshold >= 0 && n > 0 && goods >= GIFT.threshold - 0.0001,
      physical: n > 0
    };
  }
  function bagCount() { return totals().items; }
  /* eerst meteen tonen, dan de winkelmand bijwerken; bij een fout (bijvoorbeeld op = op) terug naar wat Shopify zegt */
  function bagAddMany(list) {
    list = list.filter(function (x) { return byVariant[x[0]] && x[1] > 0; }); if (!list.length) return;
    list.forEach(function (x) { bag[x[0]] = Math.min(20, (bag[x[0]] || 0) + x[1]); }); renderBag();
    queue = queue.then(function () { return api(R.cartAdd + '.js', { items: list.map(function (x) { return { id: +x[0], quantity: x[1] }; }) }); }).then(refresh).catch(fail);
  }
  function bagSet(id, n) {
    n = Math.max(0, Math.min(20, n | 0)); if (n) bag[id] = n; else delete bag[id]; renderBag();
    queue = queue.then(function () { return api(R.cartChange + '.js', { id: String(id), quantity: n }); }).then(refresh).catch(fail);
  }
  function bagAdd(id, n) { if (!byVariant[id]) return; if (n > 0) bagAddMany([[id, n]]); else bagSet(id, (bag[id] || 0) + n); }
  function bagClear() { bag = {}; renderBag(); queue = queue.then(function () { return api(R.cartClear + '.js', {}); }).then(refresh).catch(fail); }

  /* de meter: loopt mee met het aantal artikelen. 1 = volle prijs, 2 = eerste trede, 3 of meer = de volle korting */
  /* de wijzer: eigen tekening van het product, met de punt of de applicator op het eind van de balk */
  var PTR = {
    liner: '<svg viewBox="0 0 60 10" aria-hidden="true"><rect x="0" y="1" width="42" height="8" fill="#17110E"/><rect x="42" y="1.4" width="6" height="7.2" fill="#8B7F76"/><path d="M48 1.6 60 5 48 8.4z" fill="#C11D3E"/></svg>',
    gloss: '<svg viewBox="0 0 60 16" aria-hidden="true"><path d="M2 1.5Q0 1.5 0 8t2 6.5L40 12V4z" fill="#17110E"/><rect x="40" y="3.2" width="7" height="9.6" fill="#17110E"/><rect x="47" y="5" width="4" height="6" fill="#17110E"/><path d="M51 5.4h4.4Q60 5.4 60 8t-4.600 2.600H51z" fill="#B9B2AA"/></svg>',
    pink: '<svg viewBox="0 0 60 16" aria-hidden="true"><path d="M2 1.5Q0 1.5 0 8t2 6.5L40 12V4z" fill="#fff" stroke="#CFC2B5" stroke-width=".8"/><rect x="40" y="3.2" width="7" height="9.6" fill="#fff" stroke="#CFC2B5" stroke-width=".8"/><rect x="47" y="5" width="4" height="6" fill="#fff" stroke="#CFC2B5" stroke-width=".8"/><path d="M51 5.4h4.4Q60 5.4 60 8t-4.600 2.600H51z" fill="#B9B2AA"/></svg>'
  };
  function meterHTML(t, opt) {
    opt = opt || {};
    var kind = opt.pointer || (L.METER || {}).pointer || 'none';
    var n = Math.min(t.n, 3), l = LAD, msg;
    if (t.n === 0) msg = 'Add <b>2 items</b> for <b>' + l[1] + '% off</b>, <b>3 or more</b> for <b>' + l[2] + '% off</b> your whole order.';
    else if (n === 1) msg = 'Add <b>1 more item</b> to unlock <b>' + l[1] + '% off</b> your whole order.';
    else if (n === 2) msg = 'You unlocked <b>' + l[1] + '% off</b>. Add <b>1 more item</b> for the full <b>' + l[2] + '%</b>.';
    else msg = 'You unlocked the full <b>' + l[2] + '% off</b> your whole order.';
    var steps = [['1 item', l[0] ? l[0] + '% off' : 'Full price'], ['2 items', l[1] + '% off'], ['3 or more', l[2] + '% off']];
    return '<div class="meter' + (n >= 3 ? ' is-full' : '') + (opt.cls ? ' ' + opt.cls : '') + '" data-n="' + n + '">' +
      '<p class="meter__msg">' + (opt.msg || msg) + '</p>' +
      '<div class="meter__bar' + (PTR[kind] ? ' has-ptr' : '') + '">' + (PTR[kind] && n > 0 ? '<i class="meter__ptr meter__ptr--' + kind + '" style="left:' + (n / 3 * 100).toFixed(2) + '%">' + PTR[kind] + '</i>' : '') +
      '<div class="meter__track" role="progressbar" aria-valuemin="0" aria-valuemax="3" aria-valuenow="' + n + '" aria-label="Routine saving"><i class="meter__fill" style="width:' + (n / 3 * 100).toFixed(2) + '%"></i><span></span><span></span></div></div>' +
      '<div class="meter__steps">' + steps.map(function (s, i) {
        return '<div class="meter__step' + (n - 1 >= i ? ' is-on' : '') + (n === i && n < 3 ? ' is-next' : '') + (i === 0 && !l[0] ? ' is-flat' : '') + '"><b>' + s[0] + '</b>' + s[1] + '</div>';
      }).join('') + '</div>' +
      (t.pct && !opt.noSave ? '<p class="meter__save">You save ' + money(t.disc) + '</p>' : '') +
      '<p class="meter__note">' + PROMO.note + '</p>' +
    '</div>';
  }

  /* wat past erbij: eerst wat de routine afmaakt (line, gloss, care), daarna wat het ruimst op voorraad is */
  var STEP_ORDER = ['line', 'gloss', 'care'];
  function stepOf(p) { return (DETAILS[p.handle] || {}).step; }
  function recommend(b, max, skipHandle) {
    b = b || bag; max = max || 3;
    var have = {}, out = [];
    Object.keys(b).forEach(function (id) { var x = byVariant[id]; if (x) have[stepOf(x.p)] = true; });
    var best = ROUTINES[0], score = -1;
    ROUTINES.forEach(function (r) { var s = r.picks.filter(function (id) { return b[id]; }).length; if (s > score) { score = s; best = r; } });
    var push = function (id) {
      var x = byVariant[id];
      if (!x || b[id] || x.v.stock === 0 || x.p.handle === skipHandle) return;
      if (out.some(function (o) { return o.p === x.p; })) return;
      out.push(x);
    };
    if (best) best.picks.forEach(function (id, k) { if (!have[STEP_ORDER[k]]) push(id); });
    [['pink-cloud'], ['lip-butter-balm', 'Birthday Cake'], ['signature-gloss'], ['lip-liner', 'Nude Muse 22'], ['lip-glow-oil', 'Peach Lumiere'], ['signature-glow-duo'], ['the-kiss-edit']].forEach(function (x) { var id = vidOf(x[0], x[1]); if (id) push(id); });
    return out.slice(0, max);
  }
  /* de routine van drie rond één product (productpagina): het product zelf op zijn eigen stap */
  function routineFor(p, v) {
    var k = STEP_ORDER.indexOf(stepOf(p)); if (k < 0 || !ROUTINES.length) return null;
    var r = ROUTINES.filter(function (x) { return x.picks.indexOf(v.id) > -1; })[0] || ROUTINES[k === 1 ? 1 : 0];
    var picks = r.picks.slice(); picks[k] = v.id;
    return picks;
  }
  function recsHTML(list, t, title) {
    if (!list.length) return '';
    var l = LAD, head = title || (t.n === 1 ? 'Add one, take ' + l[1] + '% off both' : t.n === 2 ? 'One more for ' + l[2] + '% off everything' : 'You may also like');
    return '<div class="recs"><p class="label recs__h">' + head + '</p>' + list.map(function (x) {
      return '<div class="rec"><a class="rec__img" href="' + urlOf(x.p, x.v) + '"><img ' + srcAttrs(x.v.image, SZ.line) + ' alt="' + esc(x.p.title) + '" loading="lazy"></a>' +
        '<div class="rec__b"><a class="rec__t" href="' + urlOf(x.p, x.v) + '">' + esc(x.p.title) + '</a><p class="rec__v">' + (x.p.option ? esc(x.v.title) + ' · ' : '') + money(x.v.price) + '</p></div>' +
        '<button type="button" class="rec__add" data-rec="' + x.v.id + '" aria-label="Add ' + esc(x.p.title) + ' to bag">' + icon('plus') + '<span>Add</span></button></div>';
    }).join('') + '</div>';
  }
  function lineHTML(id, q) {
    var x = byVariant[id];
    return '<div class="line" data-line="' + id + '"><a class="line__img" href="' + urlOf(x.p, x.v) + '"><img ' + srcAttrs(x.v.image, SZ.line) + ' alt=""></a><div>' +
      '<p class="line__t"><a href="' + urlOf(x.p, x.v) + '">' + esc(x.p.title) + '</a></p>' +
      (x.p.option ? '<p class="line__v"><span class="sw__dot" style="width:12px;height:12px;background:' + x.v.color + '"></span>' + esc(x.v.title) + '</p>' : '<p class="line__v">' + esc(x.p.subtitle) + '</p>') +
      '<div class="qty"><button type="button" data-q="-1" data-id="' + id + '" aria-label="One less">−</button><span>' + q + '</span><button type="button" data-q="1" data-id="' + id + '" aria-label="One more">+</button></div></div>' +
      '<div><p class="line__p">' + money(x.v.price * q) + '</p><button type="button" class="line__rm" data-rm="' + id + '">Remove</button></div></div>';
  }
  function giftHTML() {
    return '<div class="line line--gift"><div class="line__img"><img src="' + IMAGES['gift-mirror'] + '" alt="" style="object-position:72% center"></div><div><p class="line__t">' + esc(GIFT.name) + '</p><p class="line__v">' + (GIFT.threshold > 0 ? 'Our gift with orders from ' + euro(GIFT.threshold) : 'Our gift with your order') + '</p></div><div><p class="line__p">Free</p></div></div>';
  }
  /* verzendkosten in één zin; buiten de EU een bedrag zodra SHIPPING.world is ingevuld */
  function shipWorld() { return SHIP.world != null ? 'Worldwide shipping is ' + money(SHIP.world) + '.' : 'We also ship worldwide. That rate is calculated at checkout.'; }
  function shipLine() { return 'Shipping is not included in the price and is added at checkout: ' + money(SHIP.nl) + ' in the Netherlands, ' + money(SHIP.eu) + ' in the EU. ' + shipWorld(); }
  function sumHTML(t, opt) {
    opt = opt || {};
    return '<div><span>Subtotal</span><span>' + money(t.sub) + '</span></div>' +
      (t.pct ? '<div class="sum__disc"><span>Routine saving (' + t.pct + '%)' + (opt.applied ? '' : '<small>applied at checkout</small>') + '</span><span>−' + money(t.disc) + '</span></div>' : '') +
      (opt.shipText ? '<div><span>Shipping' + (opt.shipLabel ? ' · ' + opt.shipLabel : '') + '</span><span>' + esc(opt.shipText) + '</span></div>'
        : opt.ship != null ? '<div><span>Shipping' + (opt.shipLabel ? ' · ' + opt.shipLabel : '') + '</span><span>' + (opt.ship ? money(opt.ship) : 'Free') + '</span></div>' : '') +
      '<div class="sum__total"><span>' + (opt.totalLabel || (opt.ship == null && !opt.shipText && t.physical ? 'Total before shipping' : 'Total')) + '</span><span>' + money(t.total + (opt.ship || 0)) + '</span></div>';
  }
  function renderBag() {
    var t = totals(), n = t.items, cnt = $('#bagCount'), body = $('#bagBody'), foot = $('#bagFoot'), l = LAD;
    if (cnt) {
      if (String(n) !== cnt.textContent && n > 0) { cnt.classList.remove('is-bump'); void cnt.offsetWidth; cnt.classList.add('is-bump'); }
      cnt.textContent = n; cnt.hidden = n === 0;
    }
    if (body) {
      $('#bagTitle').textContent = 'Your bag' + (n ? ' (' + n + ')' : '');
      if (!n) {
        body.innerHTML = '<div class="bag-empty"><p class="serif" style="font-size:24px;color:var(--ink)">Your bag is empty.</p><p>Two items, ' + l[1] + '% off. Three or more, ' + l[2] + '% off your whole order, applied at checkout.</p><a class="btn btn--solid" href="' + R.routine + '">Build your routine</a></div>' +
          recsHTML(recommend({}, 3), t, 'Start with a bestseller');
        foot.hidden = true;
      } else {
        var html = meterHTML(t);
        Object.keys(bag).forEach(function (id) { html += lineHTML(id, bag[id]); });
        if (t.gift) html += giftHTML();
        html += recsHTML(recommend(bag, 3), t);
        body.innerHTML = html;
        $('#bagSum').innerHTML = sumHTML(t);
        foot.hidden = false;
      }
    }
    bagSubs.forEach(function (fn) { fn(t); });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-q]'); if (q) { bagAdd(q.dataset.id, +q.dataset.q); return; }
    var r = e.target.closest('[data-rm]'); if (r) { bagSet(r.dataset.rm, 0); return; }
    var c = e.target.closest('[data-rec]'); if (c) { bagAdd(c.dataset.rec, 1); return; }
  });
  /* terug naar de pagina met de knop Vorige: de winkelmand opnieuw ophalen */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  renderBag(); markGift();

  /* ---------- hero: tekst, foto en film wisselen samen ---------- */
  (function () {
    var hero = $('.hero'); if (!hero) return;
    var txt = $$('.hs', hero), photo = $$('.hp', hero), film = $$('.hv', hero), dots = $('#heroDots'), cnt = $('#heroCount'), pauseB = $('#heroPause');
    var n = txt.length, i = 0, t, DUR = 8000, paused = REDUCE, inView = true;
    if (!n) return;
    hero.style.setProperty('--dur', DUR + 'ms');
    dots.innerHTML = txt.map(function (_, k) { return '<button type="button" class="dot" aria-label="Slide ' + (k + 1) + '"></button>'; }).join('');
    var dotEls = $$('.dot', dots);
    function set(list, cls) { list.forEach(function (el, x) { var on = x === i % list.length; el.classList.toggle(cls || 'is-on', on); el.setAttribute('aria-hidden', !on); }); }
    function show(k) {
      i = (k + n) % n;
      set(txt); set(photo); set(film);
      /* de foto van nu en de volgende alvast binnenhalen, zodat de wissel nooit op een leeg vlak uitkomt */
      [i, i + 1].forEach(function (x) { var im = photo.length && $('img', photo[x % photo.length]); if (im && im.loading === 'lazy') im.loading = 'eager'; });
      dotEls.forEach(function (d, x) { d.classList.remove('is-on'); void d.offsetWidth; d.classList.toggle('is-on', x === i); });
      film.forEach(function (v, x) {
        if (x === i % film.length) { armVideo(v); try { v.currentTime = 0; } catch (err) {} if (!paused && inView) playVideo(v); }
        else if (!v.paused) setTimeout(function () { if (!v.classList.contains('is-on')) v.pause(); }, 1100);
      });
      cnt.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + n).slice(-2);
    }
    function play() { clearInterval(t); if (!paused && inView) t = setInterval(function () { show(i + 1); }, DUR); }
    function go(k) { show(k); play(); }
    function setPaused(p) {
      paused = p; hero.classList.toggle('is-paused', p);
      pauseB.setAttribute('aria-pressed', p); pauseB.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow');
      $('use', pauseB).setAttribute('href', p ? '#i-play' : '#i-pause');
      var v = film[i % film.length];
      if (p) { clearInterval(t); if (v) v.pause(); } else { if (v) playVideo(v); go(i); }
    }
    dots.addEventListener('click', function (e) { var d = e.target.closest('.dot'); if (d) go(dotEls.indexOf(d)); });
    $('#heroPrev').addEventListener('click', function () { go(i - 1); });
    $('#heroNext').addEventListener('click', function () { go(i + 1); });
    pauseB.addEventListener('click', function () { setPaused(!paused); });
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 48) go(i + (dx < 0 ? 1 : -1)); x0 = null; }, { passive: true });
    /* buiten beeld: film en wissel stil, dat scheelt batterij en data */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        inView = es[0].isIntersecting; var v = film[i % film.length];
        if (inView) { if (!paused) { if (v) playVideo(v); play(); } } else { clearInterval(t); if (v) v.pause(); }
      }, { threshold: 0.15 }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearInterval(t); else play(); });
    show(0); if (REDUCE) setPaused(true); else play();

    /* grote lopende regel: inhoud verdubbelen zodat de lus naadloos is */
    var band = $('#heroBand');
    if (band && !REDUCE) { var b0 = band.innerHTML; band.innerHTML = b0 + b0 + b0 + b0; }

    /* foto en film bewegen licht mee met de muis en met het scrollen (alleen met een muis, niet bij minder beweging) */
    if (!REDUCE) {
      var tx = 0, ty = 0, cx = 0, cy = 0, sy = 0, raf = null, fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
      var tick = function () {
        cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
        hero.style.setProperty('--mx', cx.toFixed(3)); hero.style.setProperty('--my', cy.toFixed(3)); hero.style.setProperty('--sy', sy.toFixed(1));
        raf = (Math.abs(tx - cx) > 0.002 || Math.abs(ty - cy) > 0.002) ? requestAnimationFrame(tick) : null;
      };
      var kick = function () { if (!raf) raf = requestAnimationFrame(tick); };
      if (fine) {
        hero.addEventListener('mousemove', function (e) { var r = hero.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width * 2 - 1; ty = (e.clientY - r.top) / r.height * 2 - 1; kick(); });
        hero.addEventListener('mouseleave', function () { tx = 0; ty = 0; kick(); });
      }
      window.addEventListener('scroll', function () { if (!inView) return; sy = Math.min(60, window.scrollY * 0.07); hero.style.setProperty('--sy', sy.toFixed(1)); }, { passive: true });
    }
  })();

  /* ---------- film-rail: speelt zodra hij in beeld is ---------- */
  (function () {
    var vids = $$('.film video'); if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { armVideo(v); v.controls = true; }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { var v = en.target; if (en.isIntersecting) { if (REDUCE) { armVideo(v); v.controls = true; } else playVideo(v); } else if (!v.paused) v.pause(); });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  })();

  /* ---------- routine builder: kant-en-klare routines, elke stap te wisselen ---------- */
  (function () {
    var host = $('#steps'); if (!host) return;
    if (!byHandle['lip-liner'] || !byHandle['lip-butter-balm'] || !ROUTINES.length) { var sec = host.closest('section'); if (sec) sec.hidden = true; return; }
    var STEPS = [
      { n: 'Step 1', name: 'Line', products: ['lip-liner'], sel: 0 },
      { n: 'Step 2', name: 'Gloss', products: ['signature-gloss', 'pink-cloud', 'lip-glow-oil'].filter(function (h) { return byHandle[h]; }), sel: 0 },
      { n: 'Step 3', name: 'Care', products: ['lip-butter-balm'], sel: 0 }
    ];
    STEPS.forEach(function (s) { s.pi = 0; s.on = true; });
    var presetsEl = $('#presets');
    function cur(s) { var p = byHandle[s.products[s.pi]]; return { p: p, v: p.variants[Math.min(s.sel, p.variants.length - 1)] }; }
    function priceOf(r) { var sub = r.picks.reduce(function (a, id) { return a + byVariant[id].v.price; }, 0), pct = PHASE.ladder[Math.min(r.picks.length, 3) - 1]; return sub - discOf(sub, pct); }
    function apply(r) {
      r.picks.forEach(function (id, k) {
        var x = byVariant[id], s = STEPS[k]; if (!x || !s) return;
        var pi = s.products.indexOf(x.p.handle); if (pi < 0) return;
        s.pi = pi; s.sel = x.p.variants.indexOf(x.v); s.on = true;
      });
    }
    function activePreset() {
      var ids = STEPS.map(function (s) { return s.on ? cur(s).v.id : null; }).join(',');
      for (var k = 0; k < ROUTINES.length; k++) if (ROUTINES[k].picks.join(',') === ids) return ROUTINES[k].id;
      return null;
    }
    function render() {
      if (presetsEl) {
        var act = activePreset();
        presetsEl.innerHTML = ROUTINES.map(function (r) {
          return '<button type="button" class="preset' + (r.id === act ? ' is-on' : '') + '" data-r="' + r.id + '" aria-pressed="' + (r.id === act) + '"><span class="preset__c" style="background:' + r.color + '"></span><span><b>' + esc(r.name) + '</b><small><s>' + money(r.picks.reduce(function (a, id) { return a + byVariant[id].v.price; }, 0)) + '</s><em>' + money(priceOf(r)) + '</em></small></span></button>';
        }).join('');
      }
      host.innerHTML = STEPS.map(function (s, k) {
        var c = cur(s), p = c.p, vi = p.variants.indexOf(c.v);
        return '<div class="step' + (s.on ? '' : ' is-off') + '" data-k="' + k + '">' +
          '<div class="step__head"><span class="label">' + s.name + '</span><span class="step__n">' + s.n + '</span></div>' +
          '<div class="step__img"><img ' + srcAttrs(c.v.image, SZ.step) + ' alt="' + esc(p.title) + '"></div>' +
          '<div class="step__body">' +
            (s.products.length > 1 ? '<div class="step__opts">' + s.products.map(function (h, x) { return '<button type="button" class="opt' + (x === s.pi ? ' is-on' : '') + '" data-pi="' + x + '">' + esc(byHandle[h].title) + '</button>'; }).join('') + '</div>' : '') +
            '<p class="step__t">' + esc(p.title) + '</p>' +
            '<p class="step__p">' + (p.option ? esc(c.v.title) + ' · ' : '') + money(c.v.price) + '</p>' +
            (p.option ? '<div class="sw">' + p.variants.map(function (v, x) { return '<button type="button" class="sw__dot' + (x === vi ? ' is-on' : '') + '" style="background:' + v.color + '" data-vi="' + x + '" aria-label="' + esc(v.title) + '" title="' + esc(v.title) + '"></button>'; }).join('') + '</div>' : '') +
            '<button type="button" class="step__skip" data-skip>' + (s.on ? 'Skip this step' : 'Add this step') + '</button>' +
          '</div></div>';
      }).join('');
      var on = STEPS.filter(function (s) { return s.on; }), n = on.length, sub = on.reduce(function (a, s) { return a + cur(s).v.price; }, 0), pct = n ? PHASE.ladder[Math.min(n, 3) - 1] : 0, disc = discOf(sub, pct), tot = sub - disc;
      var L2 = PHASE.ladder, nextPct = n === 1 ? L2[1] : n === 2 ? L2[2] : 0;
      $('#rsumL').innerHTML = !n ? 'Choose at least one step' :
        '<b>' + n + (n === 1 ? ' item' : ' items') + '</b>' +
        (pct ? '<span class="rsum__save">You save <b>' + pct + '%</b> · ' + money(disc) + '</span><span class="rsum__note">' + PROMO.short + '</span>' : '') +
        (nextPct > pct ? '<span class="rsum__next"><b>1 more item</b> for <b>' + nextPct + '%</b> off your whole order</span>' : '');
      $('#rsumT').innerHTML = '<small>' + (pct ? 'Routine price' : 'Price') + '</small>' + (pct ? '<s>' + money(sub) + '</s>' : '') + '<b' + (pct ? ' class="is-sale"' : '') + '>' + money(tot) + '</b>';
      $('#rsum').classList.toggle('is-sale', pct > 0);
      $('#rsumAdd').disabled = !n;
      $$('#ladder li').forEach(function (li, x) { li.classList.toggle('is-on', n > 0 && Math.min(n, 3) - 1 === x); });
    }
    if (presetsEl) presetsEl.addEventListener('click', function (e) {
      var b = e.target.closest('.preset'); if (!b) return;
      var r = ROUTINES.filter(function (x) { return x.id === b.dataset.r; })[0];
      if (r) { apply(r); render(); host.classList.remove('is-fresh'); void host.offsetWidth; host.classList.add('is-fresh'); }
    });
    host.addEventListener('click', function (e) {
      var st = e.target.closest('.step'); if (!st) return; var s = STEPS[+st.dataset.k];
      var o = e.target.closest('[data-pi]'), v = e.target.closest('[data-vi]');
      if (o) { s.pi = +o.dataset.pi; s.sel = 0; s.on = true; }
      else if (v) { s.sel = +v.dataset.vi; s.on = true; }
      else if (e.target.closest('[data-skip]')) s.on = !s.on;
      else return;
      render();
    });
    $('#rsumAdd').addEventListener('click', function () { bagAddMany(STEPS.filter(function (s) { return s.on; }).map(function (s) { return [cur(s).v.id, 1]; })); openDrawer('bag'); });
    /* ' + R.routine + '#nude opent op die tintfamilie */
    var want = (window.location.hash || '').slice(1), wr = ROUTINES.filter(function (x) { return x.id === want; })[0];
    if (ROUTINES.length) apply(wr || ROUTINES[0]);
    render();
  })();

  /* ---------- tintkiezer liners ---------- */
  (function () {
    var host = $('#finderShades'); if (!host) return;
    var p = byHandle['lip-liner']; if (!p || p.variants.length < 2) { var fs = host.closest('section'); if (fs) fs.hidden = true; return; }
    var i = 1, im = $('#finderImg');
    function render() {
      var v = p.variants[i];
      host.innerHTML = p.variants.map(function (x, k) { return '<button type="button" class="shade' + (k === i ? ' is-on' : '') + '" data-k="' + k + '" aria-pressed="' + (k === i) + '"><span class="shade__c" style="background:' + x.color + '"></span>' + esc(x.title.replace(/ \d+$/, '')) + '</button>'; }).join('');
      $('#finderName').textContent = v.title; $('#finderDesc').textContent = v.note + ' · ' + money(v.price);
      if (im.getAttribute('data-key') !== v.image) {
        im.setAttribute('data-key', v.image); im.classList.add('is-swap');
        setTimeout(function () { setImg(im, v.image, SZ.finder); im.alt = 'Lip Liner in ' + v.title; var done = function () { im.classList.remove('is-swap'); }; if (im.complete) done(); else im.onload = im.onerror = done; }, 180);
      }
    }
    host.addEventListener('click', function (e) { var b = e.target.closest('.shade'); if (b) { i = +b.dataset.k; render(); } });
    $('#finderAdd').addEventListener('click', function () { bagAdd(p.variants[i].id, 1); openDrawer('bag'); });
    render();
  })();

  /* ---------- nieuwsbrief (voorbeeld) ---------- */
  /* nieuwsbrief: het Shopify formulier (customer) doet het werk; na versturen staat ?customer_posted=true in het adres */

  /* ---------- binnenkomen bij scrollen ---------- */
  fillImages(document);
  var REVEAL = '.rise, .stag';
  function countUp(el) {
    var to = +el.getAttribute('data-to'), t0 = null, dur = 900;
    var step = function (t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
    el.textContent = '0'; requestAnimationFrame(step);
  }
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in'); io.unobserve(en.target);
        if (!REDUCE) $$('.cnt[data-to]', en.target).forEach(countUp);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
  }
  function reveal(root) { $$(REVEAL, root).forEach(function (el) { if (el.classList.contains('is-in')) return; if (io) io.observe(el); else el.classList.add('is-in'); }); }
  reveal(document);

  /* ---------- lichte diepte op de twee grote beelden: ze schuiven iets trager dan de pagina ---------- */
  (function () {
    var els = $$('[data-parallax]'); if (!els.length || REDUCE) return;
    var ticking = false;
    function upd() {
      ticking = false; var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.bottom < -80 || r.top > vh + 80) return;
        var k = ((r.top + r.height / 2) - vh / 2) / vh;          /* -0.5 boven, 0 midden, 0.5 onder */
        el.style.setProperty('--py', (-k * 34).toFixed(1));
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd); upd();
  })();

  /* ---------- gedeeld met lume-shop.js (collectie, productpagina, winkelmandpagina, kassa) ---------- */
  window.LUMEUI = {
    $: $, $$: $$, money: money, euro: euro, esc: esc, icon: icon, discOf: discOf, REDUCE: REDUCE,
    byHandle: byHandle, byVariant: byVariant, urlOf: urlOf, PROMO: PROMO, LAD: LAD, SZ: SZ, STARS: STARS,
    srcAttrs: srcAttrs, setImg: setImg, fillImages: fillImages, fillPromo: fillPromo, reveal: reveal,
    cardHTML: cardHTML, promoHTML: promoHTML, miniHTML: miniHTML, badgesFor: badgesFor, shotLabel: shotLabel,
    toast: toast, openDrawer: openDrawer, closeDrawer: closeDrawer,
    bag: { get: function () { return bag; }, add: bagAdd, addMany: bagAddMany, set: bagSet, clear: bagClear, totals: totals, onChange: function (fn) { bagSubs.push(fn); } },
    vidOf: vidOf, R: R,
    meterHTML: meterHTML, shipLine: shipLine, shipWorld: shipWorld, lineHTML: lineHTML, giftHTML: giftHTML, sumHTML: sumHTML, recsHTML: recsHTML,
    recommend: recommend, routineFor: routineFor, stepOf: stepOf,
    REVIEWS: REVIEWS, reviewsOf: reviewsOf, rateHTML: rateHTML, reviewHTML: reviewHTML
  };
})();
